import { render } from "./DataFilters.vue?vue&type=template&id=d5541896"
import script from "./DataFilters.vue?vue&type=script&lang=js"
export * from "./DataFilters.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataTable/DataFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5541896"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5541896', __exports__)) {
    console.log('reload')
    api.reload('d5541896', __exports__)
  }
  
  module.hot.accept("./DataFilters.vue?vue&type=template&id=d5541896", () => {
    console.log('re-render')
    api.rerender('d5541896', render)
  })

}


export default __exports__